import { render, staticRenderFns } from "./moveToBudgetFLA.vue?vue&type=template&id=67a86bf5&"
import script from "./moveToBudgetFLA.vue?vue&type=script&lang=js&"
export * from "./moveToBudgetFLA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports